import PortalIdParser from 'PortalIdParser';
import noAuthHttp from '../../http/noAuthApiClient';
const LIVECHAT_PUBLIC_API_PREFIX = 'livechat-public/v1';
export function recordCustomerAgentDeliveryReceipt({
  threadId,
  messageId,
  sessionId
}) {
  return noAuthHttp.post(`${LIVECHAT_PUBLIC_API_PREFIX}/customerAgentDeliveryReceipt/thread/${threadId}/message/${messageId}`, {
    query: {
      sessionId,
      portalId: PortalIdParser.get()
    }
  });
}